<template>
  <div class="h-screen w-screen">
    <slot />
  </div>
</template>

<script setup lang="ts">
import "@/assets/css";


</script>
